import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ShellState, SHELL_FEATURE_KEY } from './shell.reducer';

// Lookup the 'Shell' feature state managed by NgRx
const getShellState = createFeatureSelector<ShellState>(SHELL_FEATURE_KEY);

const getProfileNav = createSelector(getShellState, (state) =>
  state.headerNav.find((n) => n.identifier === 'drop-down-id'),
);
const getProfileNavError = createSelector(
  getShellState,
  (state) => state.headerNavError,
);

const getProfileNavLinks = createSelector(getProfileNav, (navItem) =>
  navItem && navItem.children ? navItem.children : [],
);

const getSiteNav = createSelector(getShellState, (state) => state.siteNav);
const getSiteNavError = createSelector(
  getShellState,
  (state) => state.siteNavError,
);
const getHasWamApproval = createSelector(
  getShellState,
  (state) => state.hasWamApproval,
);

export const shellQuery = {
  getProfileNavLinks,
  getProfileNavError,
  getSiteNav,
  getSiteNavError,
  getHasWamApproval,
};
